//@flow
import * as React from 'react'
import type { ErosQualityReviewContainer$Props } from './flowTypes'
import ContainerRowExpandPanel from '../../components/common/ContainerRowExpandPanel'
import QualityReviewContainer from '../../components/QualityReview/QualityReviewContainer'

const ErosQualityReviewContainer=(props:ErosQualityReviewContainer)=>{
    const eros = props.eros
    let isVisible = false

    if (eros.reviewQuestions && eros.reviewQuestions.length > 0){
        isVisible = true
    }
    
    return (
        <ContainerRowExpandPanel visible={isVisible} 
        title={'Final Review Before Submission'} elementId={'erosQualityReview'} 
        errors={props.noOfErros}
        >
            <QualityReviewContainer 
                elementId={'erosPanelReviewQuestion'} 
                changeFieldValue={props.changeFieldValue} 
                questions={(eros.reviewQuestions:any)} 
            />
        </ContainerRowExpandPanel>
    )
}

export default ErosQualityReviewContainer


// WEBPACK FOOTER //
// ./src/views/ProjectEros/QualityReviewContainer.js